/* tslint:disable */
/* eslint-disable */
/**
 * MIT Learn API
 * MIT public API
 *
 * The version of the OpenAPI document: 0.0.1 (v0)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
/**
 * * `dated` - Dated * `anytime` - Anytime
 * @export
 * @enum {string}
 */
export const AvailabilityEnum = {
    /**
    * Dated
    */
    Dated: 'dated',
    /**
    * Anytime
    */
    Anytime: 'anytime'
};
/**
 *
 * @export
 * @enum {string}
 */
export const BlankEnum = {
    Empty: ''
};
/**
 * * `yes` - Yes, I am looking for a certificate * `no` - No, I am not looking for a certificate * `not-sure-yet` - Not Sure
 * @export
 * @enum {string}
 */
export const CertificateDesiredEnum = {
    /**
    * Yes, I am looking for a certificate
    */
    Yes: 'yes',
    /**
    * No, I am not looking for a certificate
    */
    No: 'no',
    /**
    * Not Sure
    */
    NotSureYet: 'not-sure-yet'
};
/**
 * * `topic` - Topic * `department` - Department * `unit` - Unit * `pathway` - Pathway
 * @export
 * @enum {string}
 */
export const ChannelTypeEnum = {
    /**
    * Topic
    */
    Topic: 'topic',
    /**
    * Department
    */
    Department: 'department',
    /**
    * Unit
    */
    Unit: 'unit',
    /**
    * Pathway
    */
    Pathway: 'pathway'
};
/**
 * * `page` - page * `file` - file * `video` - video * `pdf` - pdf
 * @export
 * @enum {string}
 */
export const ContentTypeEnum = {
    /**
    * page
    */
    Page: 'page',
    /**
    * file
    */
    File: 'file',
    /**
    * video
    */
    Video: 'video',
    /**
    * pdf
    */
    Pdf: 'pdf'
};
export const CourseResourceCertificationTypeCodeEnum = {
    Micromasters: 'micromasters',
    Professional: 'professional',
    Completion: 'completion',
    None: 'none'
};
export const CourseResourceDeliveryInnerCodeEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
export const CourseResourceFormatInnerCodeEnum = {
    Synchronous: 'synchronous',
    Asynchronous: 'asynchronous'
};
export const CourseResourcePaceInnerCodeEnum = {
    SelfPaced: 'self_paced',
    InstructorPaced: 'instructor_paced'
};
/**
 *
 * @export
 * @enum {string}
 */
export const CourseResourceResourceTypeEnum = {
    Course: 'course'
};
/**
 * * `` - ---- * `Doctorate` - Doctorate * `Master\'s or professional degree` - Master\'s or professional degree * `Bachelor\'s degree` - Bachelor\'s degree * `Associate degree` - Associate degree * `Secondary/high school` - Secondary/high school * `Junior secondary/junior high/middle school` - Junior secondary/junior high/middle school * `No formal education` - No formal education * `Other education` - Other education
 * @export
 * @enum {string}
 */
export const CurrentEducationEnum = {
    /**
    * Doctorate
    */
    Doctorate: 'Doctorate',
    /**
    * Master&#39;s or professional degree
    */
    MastersOrProfessionalDegree: 'Master\'s or professional degree',
    /**
    * Bachelor&#39;s degree
    */
    BachelorsDegree: 'Bachelor\'s degree',
    /**
    * Associate degree
    */
    AssociateDegree: 'Associate degree',
    /**
    * Secondary/high school
    */
    SecondaryHighSchool: 'Secondary/high school',
    /**
    * Junior secondary/junior high/middle school
    */
    JuniorSecondaryJuniorHighMiddleSchool: 'Junior secondary/junior high/middle school',
    /**
    * No formal education
    */
    NoFormalEducation: 'No formal education',
    /**
    * Other education
    */
    OtherEducation: 'Other education'
};
/**
 * * `online` - Online * `hybrid` - Hybrid * `in_person` - In-Person * `offline` - Offline
 * @export
 * @enum {string}
 */
export const DeliveryEnum = {
    /**
    * Online
    */
    Online: 'online',
    /**
    * Hybrid
    */
    Hybrid: 'hybrid',
    /**
    * In-Person
    */
    InPerson: 'in_person',
    /**
    * Offline
    */
    Offline: 'offline'
};
/**
 * * `department` - Department
 * @export
 * @enum {string}
 */
export const DepartmentChannelTypeEnum = {
    /**
    * Department
    */
    Department: 'department'
};
/**
 *
 * @export
 * @enum {string}
 */
export const EventFeedItemFeedTypeEnum = {
    Events: 'events'
};
/**
 * * `news` - News * `events` - Events
 * @export
 * @enum {string}
 */
export const FeedSourceFeedTypeEnum = {
    /**
    * News
    */
    News: 'news',
    /**
    * Events
    */
    Events: 'events'
};
/**
 * * `academic-excellence` - Academic Boost * `career-growth` - Career Growth * `lifelong-learning` - Lifelong Learning
 * @export
 * @enum {string}
 */
export const GoalsEnum = {
    /**
    * Academic Boost
    */
    AcademicExcellence: 'academic-excellence',
    /**
    * Career Growth
    */
    CareerGrowth: 'career-growth',
    /**
    * Lifelong Learning
    */
    LifelongLearning: 'lifelong-learning'
};
/**
 *
 * @export
 * @enum {string}
 */
export const LearningPathResourceResourceTypeEnum = {
    LearningPath: 'learning_path'
};
export const LearningResourceRunLevelInnerCodeEnum = {
    Undergraduate: 'undergraduate',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Noncredit: 'noncredit',
    Advanced: 'advanced',
    Intermediate: 'intermediate',
    Introductory: 'introductory'
};
/**
 *
 * @export
 * @enum {string}
 */
export const NewsFeedItemFeedTypeEnum = {
    News: 'news'
};
/**
 *
 * @export
 * @enum {string}
 */
export const NullEnum = {
    Null: 'null'
};
/**
 * * `pathway` - Pathway
 * @export
 * @enum {string}
 */
export const PathwayChannelTypeEnum = {
    /**
    * Pathway
    */
    Pathway: 'pathway'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PodcastEpisodeResourceResourceTypeEnum = {
    PodcastEpisode: 'podcast_episode'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PodcastResourceResourceTypeEnum = {
    Podcast: 'podcast'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ProgramResourceResourceTypeEnum = {
    Program: 'program'
};
/**
 * * `news` - news * `events` - events
 * @export
 * @enum {string}
 */
export const ResourceTypeEnum = {
    /**
    * news
    */
    News: 'news',
    /**
    * events
    */
    Events: 'events'
};
/**
 * * `facebook` - facebook * `linkedin` - linkedin * `personal` - personal * `twitter` - twitter
 * @export
 * @enum {string}
 */
export const SiteTypeEnum = {
    /**
    * facebook
    */
    Facebook: 'facebook',
    /**
    * linkedin
    */
    Linkedin: 'linkedin',
    /**
    * personal
    */
    Personal: 'personal',
    /**
    * twitter
    */
    Twitter: 'twitter'
};
/**
 * * `0-to-5-hours` - <5 hours/week * `5-to-10-hours` - 5-10 hours/week * `10-to-20-hours` - 10-20 hours/week * `20-to-30-hours` - 20-30 hours/week * `30-plus-hours` - 30+ hours/week
 * @export
 * @enum {string}
 */
export const TimeCommitmentEnum = {
    /**
    * &lt;5 hours/week
    */
    _0To5Hours: '0-to-5-hours',
    /**
    * 5-10 hours/week
    */
    _5To10Hours: '5-to-10-hours',
    /**
    * 10-20 hours/week
    */
    _10To20Hours: '10-to-20-hours',
    /**
    * 20-30 hours/week
    */
    _20To30Hours: '20-to-30-hours',
    /**
    * 30+ hours/week
    */
    _30PlusHours: '30-plus-hours'
};
/**
 * * `topic` - Topic
 * @export
 * @enum {string}
 */
export const TopicChannelTypeEnum = {
    /**
    * Topic
    */
    Topic: 'topic'
};
/**
 * * `unit` - Unit
 * @export
 * @enum {string}
 */
export const UnitChannelTypeEnum = {
    /**
    * Unit
    */
    Unit: 'unit'
};
/**
 *
 * @export
 * @enum {string}
 */
export const VideoPlaylistResourceResourceTypeEnum = {
    VideoPlaylist: 'video_playlist'
};
/**
 *
 * @export
 * @enum {string}
 */
export const VideoResourceResourceTypeEnum = {
    Video: 'video'
};
/**
 * * `Markdown` - Markdown * `URL` - URL * `RSS Feed` - RSS Feed * `People` - People
 * @export
 * @enum {string}
 */
export const WidgetTypeEnum = {
    /**
    * Markdown
    */
    Markdown: 'Markdown',
    /**
    * URL
    */
    Url: 'URL',
    /**
    * RSS Feed
    */
    RssFeed: 'RSS Feed',
    /**
    * People
    */
    People: 'People'
};
/**
 * ChannelsApi - axios parameter creator
 * @export
 */
export const ChannelsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * View for retrieving an individual channel by type and name
         * @summary Channel Detail Lookup by channel type and name
         * @param {string} channel_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsCountsList: (channel_type_1, ...args_1) => __awaiter(this, [channel_type_1, ...args_1], void 0, function* (channel_type, options = {}) {
            // verify required parameter 'channel_type' is not null or undefined
            assertParamExists('channelsCountsList', 'channel_type', channel_type);
            const localVarPath = `/api/v0/channels/counts/{channel_type}/`
                .replace(`{${"channel_type"}}`, encodeURIComponent(String(channel_type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Create
         * @param {ChannelCreateRequest} ChannelCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsCreate: (ChannelCreateRequest_1, ...args_2) => __awaiter(this, [ChannelCreateRequest_1, ...args_2], void 0, function* (ChannelCreateRequest, options = {}) {
            // verify required parameter 'ChannelCreateRequest' is not null or undefined
            assertParamExists('channelsCreate', 'ChannelCreateRequest', ChannelCreateRequest);
            const localVarPath = `/api/v0/channels/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ChannelCreateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Destroy
         * @param {number} id A unique integer value identifying this channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsDestroy: (id_1, ...args_3) => __awaiter(this, [id_1, ...args_3], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('channelsDestroy', 'id', id);
            const localVarPath = `/api/v0/channels/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary List
         * @param {ChannelsListChannelTypeEnum} [channel_type] * &#x60;topic&#x60; - Topic * &#x60;department&#x60; - Department * &#x60;unit&#x60; - Unit * &#x60;pathway&#x60; - Pathway
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsList: (channel_type_2, limit_1, offset_1, ...args_4) => __awaiter(this, [channel_type_2, limit_1, offset_1, ...args_4], void 0, function* (channel_type, limit, offset, options = {}) {
            const localVarPath = `/api/v0/channels/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channel_type !== undefined) {
                localVarQueryParameter['channel_type'] = channel_type;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for listing and adding moderators
         * @summary Channel Moderators Create
         * @param {string} id
         * @param {ChannelModeratorRequest} [ChannelModeratorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsModeratorsCreate: (id_2, ChannelModeratorRequest_1, ...args_5) => __awaiter(this, [id_2, ChannelModeratorRequest_1, ...args_5], void 0, function* (id, ChannelModeratorRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('channelsModeratorsCreate', 'id', id);
            const localVarPath = `/api/v0/channels/{id}/moderators/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ChannelModeratorRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Remove the user from the moderator groups for this website
         * @summary Channel Moderators Destroy
         * @param {string} id
         * @param {string} moderator_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsModeratorsDestroy: (id_3, moderator_name_1, ...args_6) => __awaiter(this, [id_3, moderator_name_1, ...args_6], void 0, function* (id, moderator_name, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('channelsModeratorsDestroy', 'id', id);
            // verify required parameter 'moderator_name' is not null or undefined
            assertParamExists('channelsModeratorsDestroy', 'moderator_name', moderator_name);
            const localVarPath = `/api/v0/channels/{id}/moderators/{moderator_name}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"moderator_name"}}`, encodeURIComponent(String(moderator_name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for listing and adding moderators
         * @summary Channel Moderators List
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsModeratorsList: (id_4, ...args_7) => __awaiter(this, [id_4, ...args_7], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('channelsModeratorsList', 'id', id);
            const localVarPath = `/api/v0/channels/{id}/moderators/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Update
         * @param {number} id A unique integer value identifying this channel.
         * @param {PatchedChannelWriteRequest} [PatchedChannelWriteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsPartialUpdate: (id_5, PatchedChannelWriteRequest_1, ...args_8) => __awaiter(this, [id_5, PatchedChannelWriteRequest_1, ...args_8], void 0, function* (id, PatchedChannelWriteRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('channelsPartialUpdate', 'id', id);
            const localVarPath = `/api/v0/channels/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedChannelWriteRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsRetrieve: (id_6, ...args_9) => __awaiter(this, [id_6, ...args_9], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('channelsRetrieve', 'id', id);
            const localVarPath = `/api/v0/channels/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for retrieving an individual channel by type and name
         * @summary Channel Detail Lookup by channel type and name
         * @param {string} channel_type
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsTypeRetrieve: (channel_type_3, name_1, ...args_10) => __awaiter(this, [channel_type_3, name_1, ...args_10], void 0, function* (channel_type, name, options = {}) {
            // verify required parameter 'channel_type' is not null or undefined
            assertParamExists('channelsTypeRetrieve', 'channel_type', channel_type);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('channelsTypeRetrieve', 'name', name);
            const localVarPath = `/api/v0/channels/type/{channel_type}/{name}/`
                .replace(`{${"channel_type"}}`, encodeURIComponent(String(channel_type)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ChannelsApi - functional programming interface
 * @export
 */
export const ChannelsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ChannelsApiAxiosParamCreator(configuration);
    return {
        /**
         * View for retrieving an individual channel by type and name
         * @summary Channel Detail Lookup by channel type and name
         * @param {string} channel_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsCountsList(channel_type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.channelsCountsList(channel_type, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChannelsApi.channelsCountsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Create
         * @param {ChannelCreateRequest} ChannelCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsCreate(ChannelCreateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.channelsCreate(ChannelCreateRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChannelsApi.channelsCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Destroy
         * @param {number} id A unique integer value identifying this channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsDestroy(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.channelsDestroy(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChannelsApi.channelsDestroy']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary List
         * @param {ChannelsListChannelTypeEnum} [channel_type] * &#x60;topic&#x60; - Topic * &#x60;department&#x60; - Department * &#x60;unit&#x60; - Unit * &#x60;pathway&#x60; - Pathway
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsList(channel_type, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.channelsList(channel_type, limit, offset, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChannelsApi.channelsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for listing and adding moderators
         * @summary Channel Moderators Create
         * @param {string} id
         * @param {ChannelModeratorRequest} [ChannelModeratorRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsModeratorsCreate(id, ChannelModeratorRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.channelsModeratorsCreate(id, ChannelModeratorRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChannelsApi.channelsModeratorsCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Remove the user from the moderator groups for this website
         * @summary Channel Moderators Destroy
         * @param {string} id
         * @param {string} moderator_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsModeratorsDestroy(id, moderator_name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.channelsModeratorsDestroy(id, moderator_name, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChannelsApi.channelsModeratorsDestroy']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for listing and adding moderators
         * @summary Channel Moderators List
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsModeratorsList(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.channelsModeratorsList(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChannelsApi.channelsModeratorsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Update
         * @param {number} id A unique integer value identifying this channel.
         * @param {PatchedChannelWriteRequest} [PatchedChannelWriteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsPartialUpdate(id, PatchedChannelWriteRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.channelsPartialUpdate(id, PatchedChannelWriteRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChannelsApi.channelsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this channel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.channelsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChannelsApi.channelsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for retrieving an individual channel by type and name
         * @summary Channel Detail Lookup by channel type and name
         * @param {string} channel_type
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsTypeRetrieve(channel_type, name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.channelsTypeRetrieve(channel_type, name, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChannelsApi.channelsTypeRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ChannelsApi - factory interface
 * @export
 */
export const ChannelsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ChannelsApiFp(configuration);
    return {
        /**
         * View for retrieving an individual channel by type and name
         * @summary Channel Detail Lookup by channel type and name
         * @param {ChannelsApiChannelsCountsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsCountsList(requestParameters, options) {
            return localVarFp.channelsCountsList(requestParameters.channel_type, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Create
         * @param {ChannelsApiChannelsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsCreate(requestParameters, options) {
            return localVarFp.channelsCreate(requestParameters.ChannelCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Destroy
         * @param {ChannelsApiChannelsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsDestroy(requestParameters, options) {
            return localVarFp.channelsDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary List
         * @param {ChannelsApiChannelsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsList(requestParameters = {}, options) {
            return localVarFp.channelsList(requestParameters.channel_type, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * View for listing and adding moderators
         * @summary Channel Moderators Create
         * @param {ChannelsApiChannelsModeratorsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsModeratorsCreate(requestParameters, options) {
            return localVarFp.channelsModeratorsCreate(requestParameters.id, requestParameters.ChannelModeratorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the user from the moderator groups for this website
         * @summary Channel Moderators Destroy
         * @param {ChannelsApiChannelsModeratorsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsModeratorsDestroy(requestParameters, options) {
            return localVarFp.channelsModeratorsDestroy(requestParameters.id, requestParameters.moderator_name, options).then((request) => request(axios, basePath));
        },
        /**
         * View for listing and adding moderators
         * @summary Channel Moderators List
         * @param {ChannelsApiChannelsModeratorsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsModeratorsList(requestParameters, options) {
            return localVarFp.channelsModeratorsList(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Update
         * @param {ChannelsApiChannelsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsPartialUpdate(requestParameters, options) {
            return localVarFp.channelsPartialUpdate(requestParameters.id, requestParameters.PatchedChannelWriteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
         * @summary Retrieve
         * @param {ChannelsApiChannelsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsRetrieve(requestParameters, options) {
            return localVarFp.channelsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * View for retrieving an individual channel by type and name
         * @summary Channel Detail Lookup by channel type and name
         * @param {ChannelsApiChannelsTypeRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelsTypeRetrieve(requestParameters, options) {
            return localVarFp.channelsTypeRetrieve(requestParameters.channel_type, requestParameters.name, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ChannelsApi - object-oriented interface
 * @export
 * @class ChannelsApi
 * @extends {BaseAPI}
 */
export class ChannelsApi extends BaseAPI {
    /**
     * View for retrieving an individual channel by type and name
     * @summary Channel Detail Lookup by channel type and name
     * @param {ChannelsApiChannelsCountsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelsApi
     */
    channelsCountsList(requestParameters, options) {
        return ChannelsApiFp(this.configuration).channelsCountsList(requestParameters.channel_type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
     * @summary Create
     * @param {ChannelsApiChannelsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelsApi
     */
    channelsCreate(requestParameters, options) {
        return ChannelsApiFp(this.configuration).channelsCreate(requestParameters.ChannelCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
     * @summary Destroy
     * @param {ChannelsApiChannelsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelsApi
     */
    channelsDestroy(requestParameters, options) {
        return ChannelsApiFp(this.configuration).channelsDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
     * @summary List
     * @param {ChannelsApiChannelsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelsApi
     */
    channelsList(requestParameters = {}, options) {
        return ChannelsApiFp(this.configuration).channelsList(requestParameters.channel_type, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for listing and adding moderators
     * @summary Channel Moderators Create
     * @param {ChannelsApiChannelsModeratorsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelsApi
     */
    channelsModeratorsCreate(requestParameters, options) {
        return ChannelsApiFp(this.configuration).channelsModeratorsCreate(requestParameters.id, requestParameters.ChannelModeratorRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove the user from the moderator groups for this website
     * @summary Channel Moderators Destroy
     * @param {ChannelsApiChannelsModeratorsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelsApi
     */
    channelsModeratorsDestroy(requestParameters, options) {
        return ChannelsApiFp(this.configuration).channelsModeratorsDestroy(requestParameters.id, requestParameters.moderator_name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for listing and adding moderators
     * @summary Channel Moderators List
     * @param {ChannelsApiChannelsModeratorsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelsApi
     */
    channelsModeratorsList(requestParameters, options) {
        return ChannelsApiFp(this.configuration).channelsModeratorsList(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
     * @summary Update
     * @param {ChannelsApiChannelsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelsApi
     */
    channelsPartialUpdate(requestParameters, options) {
        return ChannelsApiFp(this.configuration).channelsPartialUpdate(requestParameters.id, requestParameters.PatchedChannelWriteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * CRUD Operations related to Channels. Channels may represent groups or organizations at MIT and are a high-level categorization of content.
     * @summary Retrieve
     * @param {ChannelsApiChannelsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelsApi
     */
    channelsRetrieve(requestParameters, options) {
        return ChannelsApiFp(this.configuration).channelsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for retrieving an individual channel by type and name
     * @summary Channel Detail Lookup by channel type and name
     * @param {ChannelsApiChannelsTypeRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChannelsApi
     */
    channelsTypeRetrieve(requestParameters, options) {
        return ChannelsApiFp(this.configuration).channelsTypeRetrieve(requestParameters.channel_type, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const ChannelsListChannelTypeEnum = {
    Department: 'department',
    Pathway: 'pathway',
    Topic: 'topic',
    Unit: 'unit'
};
/**
 * ChatAgentApi - axios parameter creator
 * @export
 */
export const ChatAgentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Handle a POST request to the chatbot agent.
         * @param {ChatRequestRequest} ChatRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatAgentCreate: (ChatRequestRequest_1, ...args_1) => __awaiter(this, [ChatRequestRequest_1, ...args_1], void 0, function* (ChatRequestRequest, options = {}) {
            // verify required parameter 'ChatRequestRequest' is not null or undefined
            assertParamExists('chatAgentCreate', 'ChatRequestRequest', ChatRequestRequest);
            const localVarPath = `/api/v0/chat_agent/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ChatRequestRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ChatAgentApi - functional programming interface
 * @export
 */
export const ChatAgentApiFp = function (configuration) {
    const localVarAxiosParamCreator = ChatAgentApiAxiosParamCreator(configuration);
    return {
        /**
         * Handle a POST request to the chatbot agent.
         * @param {ChatRequestRequest} ChatRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatAgentCreate(ChatRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chatAgentCreate(ChatRequestRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ChatAgentApi.chatAgentCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ChatAgentApi - factory interface
 * @export
 */
export const ChatAgentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ChatAgentApiFp(configuration);
    return {
        /**
         * Handle a POST request to the chatbot agent.
         * @param {ChatAgentApiChatAgentCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatAgentCreate(requestParameters, options) {
            return localVarFp.chatAgentCreate(requestParameters.ChatRequestRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ChatAgentApi - object-oriented interface
 * @export
 * @class ChatAgentApi
 * @extends {BaseAPI}
 */
export class ChatAgentApi extends BaseAPI {
    /**
     * Handle a POST request to the chatbot agent.
     * @param {ChatAgentApiChatAgentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatAgentApi
     */
    chatAgentCreate(requestParameters, options) {
        return ChatAgentApiFp(this.configuration).chatAgentCreate(requestParameters.ChatRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CkeditorApi - axios parameter creator
 * @export
 */
export const CkeditorApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get the settings response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ckeditorRetrieve: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/api/v0/ckeditor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CkeditorApi - functional programming interface
 * @export
 */
export const CkeditorApiFp = function (configuration) {
    const localVarAxiosParamCreator = CkeditorApiAxiosParamCreator(configuration);
    return {
        /**
         * Get the settings response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ckeditorRetrieve(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ckeditorRetrieve(options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['CkeditorApi.ckeditorRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * CkeditorApi - factory interface
 * @export
 */
export const CkeditorApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CkeditorApiFp(configuration);
    return {
        /**
         * Get the settings response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ckeditorRetrieve(options) {
            return localVarFp.ckeditorRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CkeditorApi - object-oriented interface
 * @export
 * @class CkeditorApi
 * @extends {BaseAPI}
 */
export class CkeditorApi extends BaseAPI {
    /**
     * Get the settings response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CkeditorApi
     */
    ckeditorRetrieve(options) {
        return CkeditorApiFp(this.configuration).ckeditorRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LearningResourcesSearchAdminParamsApi - axios parameter creator
 * @export
 */
export const LearningResourcesSearchAdminParamsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Learning resource search default admin param values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesSearchAdminParamsRetrieve: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/api/v0/learning_resources_search_admin_params/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LearningResourcesSearchAdminParamsApi - functional programming interface
 * @export
 */
export const LearningResourcesSearchAdminParamsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LearningResourcesSearchAdminParamsApiAxiosParamCreator(configuration);
    return {
        /**
         * Learning resource search default admin param values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesSearchAdminParamsRetrieve(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.learningResourcesSearchAdminParamsRetrieve(options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['LearningResourcesSearchAdminParamsApi.learningResourcesSearchAdminParamsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * LearningResourcesSearchAdminParamsApi - factory interface
 * @export
 */
export const LearningResourcesSearchAdminParamsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LearningResourcesSearchAdminParamsApiFp(configuration);
    return {
        /**
         * Learning resource search default admin param values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        learningResourcesSearchAdminParamsRetrieve(options) {
            return localVarFp.learningResourcesSearchAdminParamsRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LearningResourcesSearchAdminParamsApi - object-oriented interface
 * @export
 * @class LearningResourcesSearchAdminParamsApi
 * @extends {BaseAPI}
 */
export class LearningResourcesSearchAdminParamsApi extends BaseAPI {
    /**
     * Learning resource search default admin param values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningResourcesSearchAdminParamsApi
     */
    learningResourcesSearchAdminParamsRetrieve(options) {
        return LearningResourcesSearchAdminParamsApiFp(this.configuration).learningResourcesSearchAdminParamsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NewsEventsApi - axios parameter creator
 * @export
 */
export const NewsEventsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a paginated list of feed items.
         * @param {Array<NewsEventsListFeedTypeEnum>} [feed_type] The type of item  * &#x60;news&#x60; - News * &#x60;events&#x60; - Events
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {NewsEventsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;event_date&#x60; - Event date ascending * &#x60;-event_date&#x60; - Event date  descending * &#x60;news_date&#x60; - Creation date ascending * &#x60;-news_date&#x60; - Creation date descending
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsList: (feed_type_1, limit_1, offset_1, sortby_1, ...args_1) => __awaiter(this, [feed_type_1, limit_1, offset_1, sortby_1, ...args_1], void 0, function* (feed_type, limit, offset, sortby, options = {}) {
            const localVarPath = `/api/v0/news_events/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (feed_type) {
                localVarQueryParameter['feed_type'] = feed_type;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single feed item.
         * @param {number} id A unique integer value identifying this feed item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('newsEventsRetrieve', 'id', id);
            const localVarPath = `/api/v0/news_events/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NewsEventsApi - functional programming interface
 * @export
 */
export const NewsEventsApiFp = function (configuration) {
    const localVarAxiosParamCreator = NewsEventsApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a paginated list of feed items.
         * @param {Array<NewsEventsListFeedTypeEnum>} [feed_type] The type of item  * &#x60;news&#x60; - News * &#x60;events&#x60; - Events
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {NewsEventsListSortbyEnum} [sortby] Sort By  * &#x60;id&#x60; - Object ID ascending * &#x60;-id&#x60; - Object ID descending * &#x60;event_date&#x60; - Event date ascending * &#x60;-event_date&#x60; - Event date  descending * &#x60;news_date&#x60; - Creation date ascending * &#x60;-news_date&#x60; - Creation date descending
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsList(feed_type, limit, offset, sortby, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.newsEventsList(feed_type, limit, offset, sortby, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['NewsEventsApi.newsEventsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single feed item.
         * @param {number} id A unique integer value identifying this feed item.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.newsEventsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['NewsEventsApi.newsEventsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * NewsEventsApi - factory interface
 * @export
 */
export const NewsEventsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NewsEventsApiFp(configuration);
    return {
        /**
         * Get a paginated list of feed items.
         * @param {NewsEventsApiNewsEventsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsList(requestParameters = {}, options) {
            return localVarFp.newsEventsList(requestParameters.feed_type, requestParameters.limit, requestParameters.offset, requestParameters.sortby, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single feed item.
         * @param {NewsEventsApiNewsEventsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsRetrieve(requestParameters, options) {
            return localVarFp.newsEventsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NewsEventsApi - object-oriented interface
 * @export
 * @class NewsEventsApi
 * @extends {BaseAPI}
 */
export class NewsEventsApi extends BaseAPI {
    /**
     * Get a paginated list of feed items.
     * @param {NewsEventsApiNewsEventsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEventsApi
     */
    newsEventsList(requestParameters = {}, options) {
        return NewsEventsApiFp(this.configuration).newsEventsList(requestParameters.feed_type, requestParameters.limit, requestParameters.offset, requestParameters.sortby, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single feed item.
     * @param {NewsEventsApiNewsEventsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEventsApi
     */
    newsEventsRetrieve(requestParameters, options) {
        return NewsEventsApiFp(this.configuration).newsEventsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const NewsEventsListFeedTypeEnum = {
    Events: 'events',
    News: 'news'
};
/**
 * @export
 */
export const NewsEventsListSortbyEnum = {
    EventDate: '-event_date',
    Id: '-id',
    NewsDate: '-news_date',
    EventDate2: 'event_date',
    Id2: 'id',
    NewsDate2: 'news_date'
};
/**
 * NewsEventsSourcesApi - axios parameter creator
 * @export
 */
export const NewsEventsSourcesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get a paginated list of news/event feed sources.
         * @param {Array<NewsEventsSourcesListFeedTypeEnum>} [feed_type] The type of source  * &#x60;news&#x60; - News * &#x60;events&#x60; - Events
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsSourcesList: (feed_type_1, limit_1, offset_1, ...args_1) => __awaiter(this, [feed_type_1, limit_1, offset_1, ...args_1], void 0, function* (feed_type, limit, offset, options = {}) {
            const localVarPath = `/api/v0/news_events_sources/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (feed_type) {
                localVarQueryParameter['feed_type'] = feed_type;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a single news/event feed source.
         * @param {number} id A unique integer value identifying this feed source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsSourcesRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('newsEventsSourcesRetrieve', 'id', id);
            const localVarPath = `/api/v0/news_events_sources/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NewsEventsSourcesApi - functional programming interface
 * @export
 */
export const NewsEventsSourcesApiFp = function (configuration) {
    const localVarAxiosParamCreator = NewsEventsSourcesApiAxiosParamCreator(configuration);
    return {
        /**
         * Get a paginated list of news/event feed sources.
         * @param {Array<NewsEventsSourcesListFeedTypeEnum>} [feed_type] The type of source  * &#x60;news&#x60; - News * &#x60;events&#x60; - Events
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsSourcesList(feed_type, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.newsEventsSourcesList(feed_type, limit, offset, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['NewsEventsSourcesApi.newsEventsSourcesList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a single news/event feed source.
         * @param {number} id A unique integer value identifying this feed source.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsSourcesRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.newsEventsSourcesRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['NewsEventsSourcesApi.newsEventsSourcesRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * NewsEventsSourcesApi - factory interface
 * @export
 */
export const NewsEventsSourcesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NewsEventsSourcesApiFp(configuration);
    return {
        /**
         * Get a paginated list of news/event feed sources.
         * @param {NewsEventsSourcesApiNewsEventsSourcesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsSourcesList(requestParameters = {}, options) {
            return localVarFp.newsEventsSourcesList(requestParameters.feed_type, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single news/event feed source.
         * @param {NewsEventsSourcesApiNewsEventsSourcesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsEventsSourcesRetrieve(requestParameters, options) {
            return localVarFp.newsEventsSourcesRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NewsEventsSourcesApi - object-oriented interface
 * @export
 * @class NewsEventsSourcesApi
 * @extends {BaseAPI}
 */
export class NewsEventsSourcesApi extends BaseAPI {
    /**
     * Get a paginated list of news/event feed sources.
     * @param {NewsEventsSourcesApiNewsEventsSourcesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEventsSourcesApi
     */
    newsEventsSourcesList(requestParameters = {}, options) {
        return NewsEventsSourcesApiFp(this.configuration).newsEventsSourcesList(requestParameters.feed_type, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single news/event feed source.
     * @param {NewsEventsSourcesApiNewsEventsSourcesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsEventsSourcesApi
     */
    newsEventsSourcesRetrieve(requestParameters, options) {
        return NewsEventsSourcesApiFp(this.configuration).newsEventsSourcesRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const NewsEventsSourcesListFeedTypeEnum = {
    Events: 'events',
    News: 'news'
};
/**
 * ProfilesApi - axios parameter creator
 * @export
 */
export const ProfilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * View for profile
         * @param {string} user__username
         * @param {PatchedProfileRequest} [PatchedProfileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesPartialUpdate: (user__username_1, PatchedProfileRequest_1, ...args_1) => __awaiter(this, [user__username_1, PatchedProfileRequest_1, ...args_1], void 0, function* (user__username, PatchedProfileRequest, options = {}) {
            // verify required parameter 'user__username' is not null or undefined
            assertParamExists('profilesPartialUpdate', 'user__username', user__username);
            const localVarPath = `/api/v0/profiles/{user__username}/`
                .replace(`{${"user__username"}}`, encodeURIComponent(String(user__username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedProfileRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for profile
         * @param {string} user__username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesRetrieve: (user__username_2, ...args_2) => __awaiter(this, [user__username_2, ...args_2], void 0, function* (user__username, options = {}) {
            // verify required parameter 'user__username' is not null or undefined
            assertParamExists('profilesRetrieve', 'user__username', user__username);
            const localVarPath = `/api/v0/profiles/{user__username}/`
                .replace(`{${"user__username"}}`, encodeURIComponent(String(user__username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for profile
         * @param {string} user__username
         * @param {ProfileRequest} [ProfileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesUpdate: (user__username_3, ProfileRequest_1, ...args_3) => __awaiter(this, [user__username_3, ProfileRequest_1, ...args_3], void 0, function* (user__username, ProfileRequest, options = {}) {
            // verify required parameter 'user__username' is not null or undefined
            assertParamExists('profilesUpdate', 'user__username', user__username);
            const localVarPath = `/api/v0/profiles/{user__username}/`
                .replace(`{${"user__username"}}`, encodeURIComponent(String(user__username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ProfileRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProfilesApi - functional programming interface
 * @export
 */
export const ProfilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProfilesApiAxiosParamCreator(configuration);
    return {
        /**
         * View for profile
         * @param {string} user__username
         * @param {PatchedProfileRequest} [PatchedProfileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesPartialUpdate(user__username, PatchedProfileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profilesPartialUpdate(user__username, PatchedProfileRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ProfilesApi.profilesPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for profile
         * @param {string} user__username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesRetrieve(user__username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profilesRetrieve(user__username, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ProfilesApi.profilesRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for profile
         * @param {string} user__username
         * @param {ProfileRequest} [ProfileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesUpdate(user__username, ProfileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profilesUpdate(user__username, ProfileRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ProfilesApi.profilesUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ProfilesApi - factory interface
 * @export
 */
export const ProfilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProfilesApiFp(configuration);
    return {
        /**
         * View for profile
         * @param {ProfilesApiProfilesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesPartialUpdate(requestParameters, options) {
            return localVarFp.profilesPartialUpdate(requestParameters.user__username, requestParameters.PatchedProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * View for profile
         * @param {ProfilesApiProfilesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesRetrieve(requestParameters, options) {
            return localVarFp.profilesRetrieve(requestParameters.user__username, options).then((request) => request(axios, basePath));
        },
        /**
         * View for profile
         * @param {ProfilesApiProfilesUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilesUpdate(requestParameters, options) {
            return localVarFp.profilesUpdate(requestParameters.user__username, requestParameters.ProfileRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProfilesApi - object-oriented interface
 * @export
 * @class ProfilesApi
 * @extends {BaseAPI}
 */
export class ProfilesApi extends BaseAPI {
    /**
     * View for profile
     * @param {ProfilesApiProfilesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    profilesPartialUpdate(requestParameters, options) {
        return ProfilesApiFp(this.configuration).profilesPartialUpdate(requestParameters.user__username, requestParameters.PatchedProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for profile
     * @param {ProfilesApiProfilesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    profilesRetrieve(requestParameters, options) {
        return ProfilesApiFp(this.configuration).profilesRetrieve(requestParameters.user__username, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for profile
     * @param {ProfilesApiProfilesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    profilesUpdate(requestParameters, options) {
        return ProfilesApiFp(this.configuration).profilesUpdate(requestParameters.user__username, requestParameters.ProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProgramCertificatesApi - axios parameter creator
 * @export
 */
export const ProgramCertificatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * View for listing program certificates for a user (includes program letter links)
         * @param {number} [micromasters_program_id]
         * @param {string} [program_title]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programCertificatesList: (micromasters_program_id_1, program_title_1, ...args_1) => __awaiter(this, [micromasters_program_id_1, program_title_1, ...args_1], void 0, function* (micromasters_program_id, program_title, options = {}) {
            const localVarPath = `/api/v0/program_certificates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (micromasters_program_id !== undefined) {
                localVarQueryParameter['micromasters_program_id'] = micromasters_program_id;
            }
            if (program_title !== undefined) {
                localVarQueryParameter['program_title'] = program_title;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProgramCertificatesApi - functional programming interface
 * @export
 */
export const ProgramCertificatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProgramCertificatesApiAxiosParamCreator(configuration);
    return {
        /**
         * View for listing program certificates for a user (includes program letter links)
         * @param {number} [micromasters_program_id]
         * @param {string} [program_title]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programCertificatesList(micromasters_program_id, program_title, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.programCertificatesList(micromasters_program_id, program_title, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['ProgramCertificatesApi.programCertificatesList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * ProgramCertificatesApi - factory interface
 * @export
 */
export const ProgramCertificatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProgramCertificatesApiFp(configuration);
    return {
        /**
         * View for listing program certificates for a user (includes program letter links)
         * @param {ProgramCertificatesApiProgramCertificatesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        programCertificatesList(requestParameters = {}, options) {
            return localVarFp.programCertificatesList(requestParameters.micromasters_program_id, requestParameters.program_title, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProgramCertificatesApi - object-oriented interface
 * @export
 * @class ProgramCertificatesApi
 * @extends {BaseAPI}
 */
export class ProgramCertificatesApi extends BaseAPI {
    /**
     * View for listing program certificates for a user (includes program letter links)
     * @param {ProgramCertificatesApiProgramCertificatesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProgramCertificatesApi
     */
    programCertificatesList(requestParameters = {}, options) {
        return ProgramCertificatesApiFp(this.configuration).programCertificatesList(requestParameters.micromasters_program_id, requestParameters.program_title, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SyllabusAgentApi - axios parameter creator
 * @export
 */
export const SyllabusAgentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Handle a POST request to the chatbot agent.
         * @param {SyllabusChatRequestRequest} SyllabusChatRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syllabusAgentCreate: (SyllabusChatRequestRequest_1, ...args_1) => __awaiter(this, [SyllabusChatRequestRequest_1, ...args_1], void 0, function* (SyllabusChatRequestRequest, options = {}) {
            // verify required parameter 'SyllabusChatRequestRequest' is not null or undefined
            assertParamExists('syllabusAgentCreate', 'SyllabusChatRequestRequest', SyllabusChatRequestRequest);
            const localVarPath = `/api/v0/syllabus_agent/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(SyllabusChatRequestRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SyllabusAgentApi - functional programming interface
 * @export
 */
export const SyllabusAgentApiFp = function (configuration) {
    const localVarAxiosParamCreator = SyllabusAgentApiAxiosParamCreator(configuration);
    return {
        /**
         * Handle a POST request to the chatbot agent.
         * @param {SyllabusChatRequestRequest} SyllabusChatRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syllabusAgentCreate(SyllabusChatRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syllabusAgentCreate(SyllabusChatRequestRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['SyllabusAgentApi.syllabusAgentCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * SyllabusAgentApi - factory interface
 * @export
 */
export const SyllabusAgentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SyllabusAgentApiFp(configuration);
    return {
        /**
         * Handle a POST request to the chatbot agent.
         * @param {SyllabusAgentApiSyllabusAgentCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syllabusAgentCreate(requestParameters, options) {
            return localVarFp.syllabusAgentCreate(requestParameters.SyllabusChatRequestRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SyllabusAgentApi - object-oriented interface
 * @export
 * @class SyllabusAgentApi
 * @extends {BaseAPI}
 */
export class SyllabusAgentApi extends BaseAPI {
    /**
     * Handle a POST request to the chatbot agent.
     * @param {SyllabusAgentApiSyllabusAgentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyllabusAgentApi
     */
    syllabusAgentCreate(requestParameters, options) {
        return SyllabusAgentApiFp(this.configuration).syllabusAgentCreate(requestParameters.SyllabusChatRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TestimonialsApi - axios parameter creator
 * @export
 */
export const TestimonialsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * List all testimonials.
         * @summary List
         * @param {Array<number>} [channels] The channels the attestation is for
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<string>} [offerors] The offerors the attestation is for
         * @param {number} [offset] The initial index from which to return the results.
         * @param {number} [position] Only show items that exist at this position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testimonialsList: (channels_1, limit_1, offerors_1, offset_1, position_1, ...args_1) => __awaiter(this, [channels_1, limit_1, offerors_1, offset_1, position_1, ...args_1], void 0, function* (channels, limit, offerors, offset, position, options = {}) {
            const localVarPath = `/api/v0/testimonials/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (channels) {
                localVarQueryParameter['channels'] = channels;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offerors) {
                localVarQueryParameter['offerors'] = offerors;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a testimonial.
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this attestation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testimonialsRetrieve: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('testimonialsRetrieve', 'id', id);
            const localVarPath = `/api/v0/testimonials/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TestimonialsApi - functional programming interface
 * @export
 */
export const TestimonialsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TestimonialsApiAxiosParamCreator(configuration);
    return {
        /**
         * List all testimonials.
         * @summary List
         * @param {Array<number>} [channels] The channels the attestation is for
         * @param {number} [limit] Number of results to return per page.
         * @param {Array<string>} [offerors] The offerors the attestation is for
         * @param {number} [offset] The initial index from which to return the results.
         * @param {number} [position] Only show items that exist at this position
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testimonialsList(channels, limit, offerors, offset, position, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testimonialsList(channels, limit, offerors, offset, position, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TestimonialsApi.testimonialsList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * Retrieve a testimonial.
         * @summary Retrieve
         * @param {number} id A unique integer value identifying this attestation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testimonialsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testimonialsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['TestimonialsApi.testimonialsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * TestimonialsApi - factory interface
 * @export
 */
export const TestimonialsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TestimonialsApiFp(configuration);
    return {
        /**
         * List all testimonials.
         * @summary List
         * @param {TestimonialsApiTestimonialsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testimonialsList(requestParameters = {}, options) {
            return localVarFp.testimonialsList(requestParameters.channels, requestParameters.limit, requestParameters.offerors, requestParameters.offset, requestParameters.position, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a testimonial.
         * @summary Retrieve
         * @param {TestimonialsApiTestimonialsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testimonialsRetrieve(requestParameters, options) {
            return localVarFp.testimonialsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TestimonialsApi - object-oriented interface
 * @export
 * @class TestimonialsApi
 * @extends {BaseAPI}
 */
export class TestimonialsApi extends BaseAPI {
    /**
     * List all testimonials.
     * @summary List
     * @param {TestimonialsApiTestimonialsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestimonialsApi
     */
    testimonialsList(requestParameters = {}, options) {
        return TestimonialsApiFp(this.configuration).testimonialsList(requestParameters.channels, requestParameters.limit, requestParameters.offerors, requestParameters.offset, requestParameters.position, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a testimonial.
     * @summary Retrieve
     * @param {TestimonialsApiTestimonialsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestimonialsApi
     */
    testimonialsRetrieve(requestParameters, options) {
        return TestimonialsApiFp(this.configuration).testimonialsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * View for users
         * @param {UserRequest} UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCreate: (UserRequest_1, ...args_1) => __awaiter(this, [UserRequest_1, ...args_1], void 0, function* (UserRequest, options = {}) {
            // verify required parameter 'UserRequest' is not null or undefined
            assertParamExists('usersCreate', 'UserRequest', UserRequest);
            const localVarPath = `/api/v0/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(UserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for users
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersDestroy: (username_1, ...args_2) => __awaiter(this, [username_1, ...args_2], void 0, function* (username, options = {}) {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('usersDestroy', 'username', username);
            const localVarPath = `/api/v0/users/{username}/`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersList: (...args_3) => __awaiter(this, [...args_3], void 0, function* (options = {}) {
            const localVarPath = `/api/v0/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * User retrieve and update viewsets for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersMeRetrieve: (...args_4) => __awaiter(this, [...args_4], void 0, function* (options = {}) {
            const localVarPath = `/api/v0/users/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for users
         * @param {string} username
         * @param {PatchedUserRequest} [PatchedUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPartialUpdate: (username_2, PatchedUserRequest_1, ...args_5) => __awaiter(this, [username_2, PatchedUserRequest_1, ...args_5], void 0, function* (username, PatchedUserRequest, options = {}) {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('usersPartialUpdate', 'username', username);
            const localVarPath = `/api/v0/users/{username}/`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedUserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for users
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRetrieve: (username_3, ...args_6) => __awaiter(this, [username_3, ...args_6], void 0, function* (username, options = {}) {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('usersRetrieve', 'username', username);
            const localVarPath = `/api/v0/users/{username}/`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for users
         * @param {string} username
         * @param {UserRequest} UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUpdate: (username_4, UserRequest_2, ...args_7) => __awaiter(this, [username_4, UserRequest_2, ...args_7], void 0, function* (username, UserRequest, options = {}) {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('usersUpdate', 'username', username);
            // verify required parameter 'UserRequest' is not null or undefined
            assertParamExists('usersUpdate', 'UserRequest', UserRequest);
            const localVarPath = `/api/v0/users/{username}/`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(UserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         * View for users
         * @param {UserRequest} UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCreate(UserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersCreate(UserRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersApi.usersCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for users
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersDestroy(username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersDestroy(username, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersApi.usersDestroy']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersList(options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersApi.usersList']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * User retrieve and update viewsets for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersMeRetrieve(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersMeRetrieve(options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersApi.usersMeRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for users
         * @param {string} username
         * @param {PatchedUserRequest} [PatchedUserRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPartialUpdate(username, PatchedUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersPartialUpdate(username, PatchedUserRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersApi.usersPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for users
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRetrieve(username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersRetrieve(username, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersApi.usersRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for users
         * @param {string} username
         * @param {UserRequest} UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUpdate(username, UserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersUpdate(username, UserRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['UsersApi.usersUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         * View for users
         * @param {UsersApiUsersCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCreate(requestParameters, options) {
            return localVarFp.usersCreate(requestParameters.UserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * View for users
         * @param {UsersApiUsersDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersDestroy(requestParameters, options) {
            return localVarFp.usersDestroy(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * View for users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersList(options) {
            return localVarFp.usersList(options).then((request) => request(axios, basePath));
        },
        /**
         * User retrieve and update viewsets for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersMeRetrieve(options) {
            return localVarFp.usersMeRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * View for users
         * @param {UsersApiUsersPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPartialUpdate(requestParameters, options) {
            return localVarFp.usersPartialUpdate(requestParameters.username, requestParameters.PatchedUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * View for users
         * @param {UsersApiUsersRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRetrieve(requestParameters, options) {
            return localVarFp.usersRetrieve(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * View for users
         * @param {UsersApiUsersUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUpdate(requestParameters, options) {
            return localVarFp.usersUpdate(requestParameters.username, requestParameters.UserRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * View for users
     * @param {UsersApiUsersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersCreate(requestParameters, options) {
        return UsersApiFp(this.configuration).usersCreate(requestParameters.UserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for users
     * @param {UsersApiUsersDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersDestroy(requestParameters, options) {
        return UsersApiFp(this.configuration).usersDestroy(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersList(options) {
        return UsersApiFp(this.configuration).usersList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * User retrieve and update viewsets for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersMeRetrieve(options) {
        return UsersApiFp(this.configuration).usersMeRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for users
     * @param {UsersApiUsersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersPartialUpdate(requestParameters, options) {
        return UsersApiFp(this.configuration).usersPartialUpdate(requestParameters.username, requestParameters.PatchedUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for users
     * @param {UsersApiUsersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersRetrieve(requestParameters, options) {
        return UsersApiFp(this.configuration).usersRetrieve(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for users
     * @param {UsersApiUsersUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersUpdate(requestParameters, options) {
        return UsersApiFp(this.configuration).usersUpdate(requestParameters.username, requestParameters.UserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VectorContentFilesSearchApi - axios parameter creator
 * @export
 */
export const VectorContentFilesSearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Vector Search for content
         * @summary Content File Vector Search
         * @param {string} [collection_name] Manually specify the name of the Qdrant collection to query
         * @param {Array<string>} [content_feature_type] The feature type of the content file. Possible options are at api/v1/course_features/
         * @param {Array<string>} [course_number] Course number of the content file
         * @param {Array<string>} [edx_module_id] The edx_module_id of the content file
         * @param {Array<string>} [file_extension] The extension of the content file.
         * @param {Array<string>} [key] The filename of the content file
         * @param {number} [limit] Number of results to return per page
         * @param {Array<string>} [offered_by] Offeror of the content file
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<string>} [platform] platform(s) of the content file
         * @param {string} [q] The search text
         * @param {Array<string>} [resource_readable_id] The readable_id value of the parent learning resource for the content file
         * @param {Array<string>} [run_readable_id] The readable_id value of the run that the content file belongs to
         * @param {VectorContentFilesSearchRetrieveSortbyEnum} [sortby] if the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;id&#x60; - id * &#x60;-id&#x60; - -id * &#x60;resource_readable_id&#x60; - resource_readable_id * &#x60;-resource_readable_id&#x60; - -resource_readable_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vectorContentFilesSearchRetrieve: (collection_name_1, content_feature_type_1, course_number_1, edx_module_id_1, file_extension_1, key_1, limit_1, offered_by_1, offset_1, platform_1, q_1, resource_readable_id_1, run_readable_id_1, sortby_1, ...args_1) => __awaiter(this, [collection_name_1, content_feature_type_1, course_number_1, edx_module_id_1, file_extension_1, key_1, limit_1, offered_by_1, offset_1, platform_1, q_1, resource_readable_id_1, run_readable_id_1, sortby_1, ...args_1], void 0, function* (collection_name, content_feature_type, course_number, edx_module_id, file_extension, key, limit, offered_by, offset, platform, q, resource_readable_id, run_readable_id, sortby, options = {}) {
            const localVarPath = `/api/v0/vector_content_files_search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (collection_name !== undefined) {
                localVarQueryParameter['collection_name'] = collection_name;
            }
            if (content_feature_type) {
                localVarQueryParameter['content_feature_type'] = content_feature_type;
            }
            if (course_number) {
                localVarQueryParameter['course_number'] = course_number;
            }
            if (edx_module_id) {
                localVarQueryParameter['edx_module_id'] = edx_module_id;
            }
            if (file_extension) {
                localVarQueryParameter['file_extension'] = file_extension;
            }
            if (key) {
                localVarQueryParameter['key'] = key;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (resource_readable_id) {
                localVarQueryParameter['resource_readable_id'] = resource_readable_id;
            }
            if (run_readable_id) {
                localVarQueryParameter['run_readable_id'] = run_readable_id;
            }
            if (sortby !== undefined) {
                localVarQueryParameter['sortby'] = sortby;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VectorContentFilesSearchApi - functional programming interface
 * @export
 */
export const VectorContentFilesSearchApiFp = function (configuration) {
    const localVarAxiosParamCreator = VectorContentFilesSearchApiAxiosParamCreator(configuration);
    return {
        /**
         * Vector Search for content
         * @summary Content File Vector Search
         * @param {string} [collection_name] Manually specify the name of the Qdrant collection to query
         * @param {Array<string>} [content_feature_type] The feature type of the content file. Possible options are at api/v1/course_features/
         * @param {Array<string>} [course_number] Course number of the content file
         * @param {Array<string>} [edx_module_id] The edx_module_id of the content file
         * @param {Array<string>} [file_extension] The extension of the content file.
         * @param {Array<string>} [key] The filename of the content file
         * @param {number} [limit] Number of results to return per page
         * @param {Array<string>} [offered_by] Offeror of the content file
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<string>} [platform] platform(s) of the content file
         * @param {string} [q] The search text
         * @param {Array<string>} [resource_readable_id] The readable_id value of the parent learning resource for the content file
         * @param {Array<string>} [run_readable_id] The readable_id value of the run that the content file belongs to
         * @param {VectorContentFilesSearchRetrieveSortbyEnum} [sortby] if the parameter starts with \&#39;-\&#39; the sort is in descending order  * &#x60;id&#x60; - id * &#x60;-id&#x60; - -id * &#x60;resource_readable_id&#x60; - resource_readable_id * &#x60;-resource_readable_id&#x60; - -resource_readable_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vectorContentFilesSearchRetrieve(collection_name, content_feature_type, course_number, edx_module_id, file_extension, key, limit, offered_by, offset, platform, q, resource_readable_id, run_readable_id, sortby, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.vectorContentFilesSearchRetrieve(collection_name, content_feature_type, course_number, edx_module_id, file_extension, key, limit, offered_by, offset, platform, q, resource_readable_id, run_readable_id, sortby, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['VectorContentFilesSearchApi.vectorContentFilesSearchRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * VectorContentFilesSearchApi - factory interface
 * @export
 */
export const VectorContentFilesSearchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VectorContentFilesSearchApiFp(configuration);
    return {
        /**
         * Vector Search for content
         * @summary Content File Vector Search
         * @param {VectorContentFilesSearchApiVectorContentFilesSearchRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vectorContentFilesSearchRetrieve(requestParameters = {}, options) {
            return localVarFp.vectorContentFilesSearchRetrieve(requestParameters.collection_name, requestParameters.content_feature_type, requestParameters.course_number, requestParameters.edx_module_id, requestParameters.file_extension, requestParameters.key, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.q, requestParameters.resource_readable_id, requestParameters.run_readable_id, requestParameters.sortby, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VectorContentFilesSearchApi - object-oriented interface
 * @export
 * @class VectorContentFilesSearchApi
 * @extends {BaseAPI}
 */
export class VectorContentFilesSearchApi extends BaseAPI {
    /**
     * Vector Search for content
     * @summary Content File Vector Search
     * @param {VectorContentFilesSearchApiVectorContentFilesSearchRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VectorContentFilesSearchApi
     */
    vectorContentFilesSearchRetrieve(requestParameters = {}, options) {
        return VectorContentFilesSearchApiFp(this.configuration).vectorContentFilesSearchRetrieve(requestParameters.collection_name, requestParameters.content_feature_type, requestParameters.course_number, requestParameters.edx_module_id, requestParameters.file_extension, requestParameters.key, requestParameters.limit, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.q, requestParameters.resource_readable_id, requestParameters.run_readable_id, requestParameters.sortby, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const VectorContentFilesSearchRetrieveSortbyEnum = {
    Id: 'id',
    Id2: '-id',
    ResourceReadableId: 'resource_readable_id',
    ResourceReadableId2: '-resource_readable_id'
};
/**
 * VectorLearningResourcesSearchApi - axios parameter creator
 * @export
 */
export const VectorLearningResourcesSearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Vector Search for learning resources
         * @summary Vector Search
         * @param {boolean | null} [certification] True if the learning resource offers a certificate
         * @param {Array<VectorLearningResourcesSearchRetrieveCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
         * @param {Array<VectorLearningResourcesSearchRetrieveDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<VectorLearningResourcesSearchRetrieveDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean | null} [free]
         * @param {Array<VectorLearningResourcesSearchRetrieveLevelEnum>} [level]
         * @param {number} [limit] Number of results to return per page
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<VectorLearningResourcesSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<VectorLearningResourcesSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean | null} [professional]
         * @param {string} [q] The search text
         * @param {string} [readable_id] The readable id of the resource
         * @param {Array<VectorLearningResourcesSearchRetrieveResourceCategoryEnum>} [resource_category] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<VectorLearningResourcesSearchRetrieveResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vectorLearningResourcesSearchRetrieve: (certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, ocw_topic_1, offered_by_1, offset_1, platform_1, professional_1, q_1, readable_id_1, resource_category_1, resource_type_1, topic_1, ...args_1) => __awaiter(this, [certification_1, certification_type_1, course_feature_1, delivery_1, department_1, free_1, level_1, limit_1, ocw_topic_1, offered_by_1, offset_1, platform_1, professional_1, q_1, readable_id_1, resource_category_1, resource_type_1, topic_1, ...args_1], void 0, function* (certification, certification_type, course_feature, delivery, department, free, level, limit, ocw_topic, offered_by, offset, platform, professional, q, readable_id, resource_category, resource_type, topic, options = {}) {
            const localVarPath = `/api/v0/vector_learning_resources_search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (certification !== undefined) {
                localVarQueryParameter['certification'] = certification;
            }
            if (certification_type) {
                localVarQueryParameter['certification_type'] = certification_type;
            }
            if (course_feature) {
                localVarQueryParameter['course_feature'] = course_feature;
            }
            if (delivery) {
                localVarQueryParameter['delivery'] = delivery;
            }
            if (department) {
                localVarQueryParameter['department'] = department;
            }
            if (free !== undefined) {
                localVarQueryParameter['free'] = free;
            }
            if (level) {
                localVarQueryParameter['level'] = level;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (ocw_topic) {
                localVarQueryParameter['ocw_topic'] = ocw_topic;
            }
            if (offered_by) {
                localVarQueryParameter['offered_by'] = offered_by;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (platform) {
                localVarQueryParameter['platform'] = platform;
            }
            if (professional !== undefined) {
                localVarQueryParameter['professional'] = professional;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (readable_id !== undefined) {
                localVarQueryParameter['readable_id'] = readable_id;
            }
            if (resource_category) {
                localVarQueryParameter['resource_category'] = resource_category;
            }
            if (resource_type) {
                localVarQueryParameter['resource_type'] = resource_type;
            }
            if (topic) {
                localVarQueryParameter['topic'] = topic;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VectorLearningResourcesSearchApi - functional programming interface
 * @export
 */
export const VectorLearningResourcesSearchApiFp = function (configuration) {
    const localVarAxiosParamCreator = VectorLearningResourcesSearchApiAxiosParamCreator(configuration);
    return {
        /**
         * Vector Search for learning resources
         * @summary Vector Search
         * @param {boolean | null} [certification] True if the learning resource offers a certificate
         * @param {Array<VectorLearningResourcesSearchRetrieveCertificationTypeEnum>} [certification_type] The type of certificate               * &#x60;micromasters&#x60; - MicroMasters Credential * &#x60;professional&#x60; - Professional Certificate * &#x60;completion&#x60; - Certificate of Completion * &#x60;none&#x60; - No Certificate
         * @param {Array<string>} [course_feature] The course feature. Possible options are at api/v1/course_features/
         * @param {Array<VectorLearningResourcesSearchRetrieveDeliveryEnum>} [delivery] The delivery options in which the learning resource is offered               * &#x60;online&#x60; - Online * &#x60;hybrid&#x60; - Hybrid * &#x60;in_person&#x60; - In person * &#x60;offline&#x60; - Offline
         * @param {Array<VectorLearningResourcesSearchRetrieveDepartmentEnum>} [department] The department that offers the learning resource               * &#x60;1&#x60; - Civil and Environmental Engineering * &#x60;2&#x60; - Mechanical Engineering * &#x60;3&#x60; - Materials Science and Engineering * &#x60;4&#x60; - Architecture * &#x60;5&#x60; - Chemistry * &#x60;6&#x60; - Electrical Engineering and Computer Science * &#x60;7&#x60; - Biology * &#x60;8&#x60; - Physics * &#x60;9&#x60; - Brain and Cognitive Sciences * &#x60;10&#x60; - Chemical Engineering * &#x60;11&#x60; - Urban Studies and Planning * &#x60;12&#x60; - Earth, Atmospheric, and Planetary Sciences * &#x60;14&#x60; - Economics * &#x60;15&#x60; - Management * &#x60;16&#x60; - Aeronautics and Astronautics * &#x60;17&#x60; - Political Science * &#x60;18&#x60; - Mathematics * &#x60;20&#x60; - Biological Engineering * &#x60;21A&#x60; - Anthropology * &#x60;21G&#x60; - Global Languages * &#x60;21H&#x60; - History * &#x60;21L&#x60; - Literature * &#x60;21M&#x60; - Music and Theater Arts * &#x60;22&#x60; - Nuclear Science and Engineering * &#x60;24&#x60; - Linguistics and Philosophy * &#x60;CC&#x60; - Concourse * &#x60;CMS-W&#x60; - Comparative Media Studies/Writing * &#x60;EC&#x60; - Edgerton Center * &#x60;ES&#x60; - Experimental Study Group * &#x60;ESD&#x60; - Engineering Systems Division * &#x60;HST&#x60; - Medical Engineering and Science * &#x60;IDS&#x60; - Data, Systems, and Society * &#x60;MAS&#x60; - Media Arts and Sciences * &#x60;PE&#x60; - Athletics, Physical Education and Recreation * &#x60;SP&#x60; - Special Programs * &#x60;STS&#x60; - Science, Technology, and Society * &#x60;WGS&#x60; - Women\&#39;s and Gender Studies
         * @param {boolean | null} [free]
         * @param {Array<VectorLearningResourcesSearchRetrieveLevelEnum>} [level]
         * @param {number} [limit] Number of results to return per page
         * @param {Array<string>} [ocw_topic] The ocw topic name.
         * @param {Array<VectorLearningResourcesSearchRetrieveOfferedByEnum>} [offered_by] The organization that offers the learning resource               * &#x60;mitx&#x60; - MITx * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education
         * @param {number} [offset] The initial index from which to return the results
         * @param {Array<VectorLearningResourcesSearchRetrievePlatformEnum>} [platform] The platform on which the learning resource is offered               * &#x60;edx&#x60; - edX * &#x60;ocw&#x60; - MIT OpenCourseWare * &#x60;oll&#x60; - Open Learning Library * &#x60;mitxonline&#x60; - MITx Online * &#x60;bootcamps&#x60; - Bootcamps * &#x60;xpro&#x60; - MIT xPRO * &#x60;csail&#x60; - CSAIL * &#x60;mitpe&#x60; - MIT Professional Education * &#x60;see&#x60; - MIT Sloan Executive Education * &#x60;scc&#x60; - Schwarzman College of Computing * &#x60;ctl&#x60; - Center for Transportation &amp; Logistics * &#x60;whu&#x60; - WHU * &#x60;susskind&#x60; - Susskind * &#x60;globalalumni&#x60; - Global Alumni * &#x60;simplilearn&#x60; - Simplilearn * &#x60;emeritus&#x60; - Emeritus * &#x60;podcast&#x60; - Podcast * &#x60;youtube&#x60; - YouTube
         * @param {boolean | null} [professional]
         * @param {string} [q] The search text
         * @param {string} [readable_id] The readable id of the resource
         * @param {Array<VectorLearningResourcesSearchRetrieveResourceCategoryEnum>} [resource_category] The category of learning resource               * &#x60;course&#x60; - Course * &#x60;program&#x60; - Program * &#x60;learning_material&#x60; - Learning Material
         * @param {Array<VectorLearningResourcesSearchRetrieveResourceTypeEnum>} [resource_type] The type of learning resource               * &#x60;course&#x60; - course * &#x60;program&#x60; - program * &#x60;learning_path&#x60; - learning path * &#x60;podcast&#x60; - podcast * &#x60;podcast_episode&#x60; - podcast episode * &#x60;video&#x60; - video * &#x60;video_playlist&#x60; - video playlist
         * @param {Array<string>} [topic] The topic name. To see a list of options go to api/v1/topics/
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vectorLearningResourcesSearchRetrieve(certification, certification_type, course_feature, delivery, department, free, level, limit, ocw_topic, offered_by, offset, platform, professional, q, readable_id, resource_category, resource_type, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.vectorLearningResourcesSearchRetrieve(certification, certification_type, course_feature, delivery, department, free, level, limit, ocw_topic, offered_by, offset, platform, professional, q, readable_id, resource_category, resource_type, topic, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['VectorLearningResourcesSearchApi.vectorLearningResourcesSearchRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * VectorLearningResourcesSearchApi - factory interface
 * @export
 */
export const VectorLearningResourcesSearchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VectorLearningResourcesSearchApiFp(configuration);
    return {
        /**
         * Vector Search for learning resources
         * @summary Vector Search
         * @param {VectorLearningResourcesSearchApiVectorLearningResourcesSearchRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vectorLearningResourcesSearchRetrieve(requestParameters = {}, options) {
            return localVarFp.vectorLearningResourcesSearchRetrieve(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.q, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.topic, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VectorLearningResourcesSearchApi - object-oriented interface
 * @export
 * @class VectorLearningResourcesSearchApi
 * @extends {BaseAPI}
 */
export class VectorLearningResourcesSearchApi extends BaseAPI {
    /**
     * Vector Search for learning resources
     * @summary Vector Search
     * @param {VectorLearningResourcesSearchApiVectorLearningResourcesSearchRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VectorLearningResourcesSearchApi
     */
    vectorLearningResourcesSearchRetrieve(requestParameters = {}, options) {
        return VectorLearningResourcesSearchApiFp(this.configuration).vectorLearningResourcesSearchRetrieve(requestParameters.certification, requestParameters.certification_type, requestParameters.course_feature, requestParameters.delivery, requestParameters.department, requestParameters.free, requestParameters.level, requestParameters.limit, requestParameters.ocw_topic, requestParameters.offered_by, requestParameters.offset, requestParameters.platform, requestParameters.professional, requestParameters.q, requestParameters.readable_id, requestParameters.resource_category, requestParameters.resource_type, requestParameters.topic, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const VectorLearningResourcesSearchRetrieveCertificationTypeEnum = {
    Micromasters: 'micromasters',
    Professional: 'professional',
    Completion: 'completion',
    None: 'none'
};
/**
 * @export
 */
export const VectorLearningResourcesSearchRetrieveDeliveryEnum = {
    Online: 'online',
    Hybrid: 'hybrid',
    InPerson: 'in_person',
    Offline: 'offline'
};
/**
 * @export
 */
export const VectorLearningResourcesSearchRetrieveDepartmentEnum = {
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _6: '6',
    _7: '7',
    _8: '8',
    _9: '9',
    _10: '10',
    _11: '11',
    _12: '12',
    _14: '14',
    _15: '15',
    _16: '16',
    _17: '17',
    _18: '18',
    _20: '20',
    _21A: '21A',
    _21G: '21G',
    _21H: '21H',
    _21L: '21L',
    _21M: '21M',
    _22: '22',
    _24: '24',
    Cc: 'CC',
    CmsW: 'CMS-W',
    Ec: 'EC',
    Es: 'ES',
    Esd: 'ESD',
    Hst: 'HST',
    Ids: 'IDS',
    Mas: 'MAS',
    Pe: 'PE',
    Sp: 'SP',
    Sts: 'STS',
    Wgs: 'WGS'
};
/**
 * @export
 */
export const VectorLearningResourcesSearchRetrieveLevelEnum = {
    Undergraduate: 'undergraduate',
    Graduate: 'graduate',
    HighSchool: 'high_school',
    Noncredit: 'noncredit',
    Advanced: 'advanced',
    Intermediate: 'intermediate',
    Introductory: 'introductory'
};
/**
 * @export
 */
export const VectorLearningResourcesSearchRetrieveOfferedByEnum = {
    Mitx: 'mitx',
    Ocw: 'ocw',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Mitpe: 'mitpe',
    See: 'see'
};
/**
 * @export
 */
export const VectorLearningResourcesSearchRetrievePlatformEnum = {
    Edx: 'edx',
    Ocw: 'ocw',
    Oll: 'oll',
    Mitxonline: 'mitxonline',
    Bootcamps: 'bootcamps',
    Xpro: 'xpro',
    Csail: 'csail',
    Mitpe: 'mitpe',
    See: 'see',
    Scc: 'scc',
    Ctl: 'ctl',
    Whu: 'whu',
    Susskind: 'susskind',
    Globalalumni: 'globalalumni',
    Simplilearn: 'simplilearn',
    Emeritus: 'emeritus',
    Podcast: 'podcast',
    Youtube: 'youtube'
};
/**
 * @export
 */
export const VectorLearningResourcesSearchRetrieveResourceCategoryEnum = {
    Course: 'course',
    Program: 'program',
    LearningMaterial: 'learning_material'
};
/**
 * @export
 */
export const VectorLearningResourcesSearchRetrieveResourceTypeEnum = {
    Course: 'course',
    Program: 'program',
    LearningPath: 'learning_path',
    Podcast: 'podcast',
    PodcastEpisode: 'podcast_episode',
    Video: 'video',
    VideoPlaylist: 'video_playlist'
};
/**
 * WebsitesApi - axios parameter creator
 * @export
 */
export const WebsitesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * View for user websites
         * @param {UserWebsiteRequest} UserWebsiteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        websitesCreate: (UserWebsiteRequest_1, ...args_1) => __awaiter(this, [UserWebsiteRequest_1, ...args_1], void 0, function* (UserWebsiteRequest, options = {}) {
            // verify required parameter 'UserWebsiteRequest' is not null or undefined
            assertParamExists('websitesCreate', 'UserWebsiteRequest', UserWebsiteRequest);
            const localVarPath = `/api/v0/websites/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(UserWebsiteRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * View for user websites
         * @param {number} id A unique integer value identifying this user website.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        websitesDestroy: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('websitesDestroy', 'id', id);
            const localVarPath = `/api/v0/websites/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WebsitesApi - functional programming interface
 * @export
 */
export const WebsitesApiFp = function (configuration) {
    const localVarAxiosParamCreator = WebsitesApiAxiosParamCreator(configuration);
    return {
        /**
         * View for user websites
         * @param {UserWebsiteRequest} UserWebsiteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        websitesCreate(UserWebsiteRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.websitesCreate(UserWebsiteRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WebsitesApi.websitesCreate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * View for user websites
         * @param {number} id A unique integer value identifying this user website.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        websitesDestroy(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.websitesDestroy(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WebsitesApi.websitesDestroy']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WebsitesApi - factory interface
 * @export
 */
export const WebsitesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WebsitesApiFp(configuration);
    return {
        /**
         * View for user websites
         * @param {WebsitesApiWebsitesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        websitesCreate(requestParameters, options) {
            return localVarFp.websitesCreate(requestParameters.UserWebsiteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * View for user websites
         * @param {WebsitesApiWebsitesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        websitesDestroy(requestParameters, options) {
            return localVarFp.websitesDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WebsitesApi - object-oriented interface
 * @export
 * @class WebsitesApi
 * @extends {BaseAPI}
 */
export class WebsitesApi extends BaseAPI {
    /**
     * View for user websites
     * @param {WebsitesApiWebsitesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebsitesApi
     */
    websitesCreate(requestParameters, options) {
        return WebsitesApiFp(this.configuration).websitesCreate(requestParameters.UserWebsiteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * View for user websites
     * @param {WebsitesApiWebsitesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebsitesApi
     */
    websitesDestroy(requestParameters, options) {
        return WebsitesApiFp(this.configuration).websitesDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WidgetListsApi - axios parameter creator
 * @export
 */
export const WidgetListsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * API for managing widget lists
         * @param {number} id A unique integer value identifying this widget list.
         * @param {PatchedWidgetListRequest} [PatchedWidgetListRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetListsPartialUpdate: (id_1, PatchedWidgetListRequest_1, ...args_1) => __awaiter(this, [id_1, PatchedWidgetListRequest_1, ...args_1], void 0, function* (id, PatchedWidgetListRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('widgetListsPartialUpdate', 'id', id);
            const localVarPath = `/api/v0/widget_lists/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(PatchedWidgetListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * API for managing widget lists
         * @param {number} id A unique integer value identifying this widget list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetListsRetrieve: (id_2, ...args_2) => __awaiter(this, [id_2, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('widgetListsRetrieve', 'id', id);
            const localVarPath = `/api/v0/widget_lists/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * API for managing widget lists
         * @param {number} id A unique integer value identifying this widget list.
         * @param {WidgetListRequest} [WidgetListRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetListsUpdate: (id_3, WidgetListRequest_1, ...args_3) => __awaiter(this, [id_3, WidgetListRequest_1, ...args_3], void 0, function* (id, WidgetListRequest, options = {}) {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('widgetListsUpdate', 'id', id);
            const localVarPath = `/api/v0/widget_lists/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(WidgetListRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WidgetListsApi - functional programming interface
 * @export
 */
export const WidgetListsApiFp = function (configuration) {
    const localVarAxiosParamCreator = WidgetListsApiAxiosParamCreator(configuration);
    return {
        /**
         * API for managing widget lists
         * @param {number} id A unique integer value identifying this widget list.
         * @param {PatchedWidgetListRequest} [PatchedWidgetListRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetListsPartialUpdate(id, PatchedWidgetListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.widgetListsPartialUpdate(id, PatchedWidgetListRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WidgetListsApi.widgetListsPartialUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * API for managing widget lists
         * @param {number} id A unique integer value identifying this widget list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetListsRetrieve(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.widgetListsRetrieve(id, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WidgetListsApi.widgetListsRetrieve']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
        /**
         * API for managing widget lists
         * @param {number} id A unique integer value identifying this widget list.
         * @param {WidgetListRequest} [WidgetListRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetListsUpdate(id, WidgetListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.widgetListsUpdate(id, WidgetListRequest, options);
                const index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const operationBasePath = (_c = (_b = operationServerMap['WidgetListsApi.widgetListsUpdate']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
            });
        },
    };
};
/**
 * WidgetListsApi - factory interface
 * @export
 */
export const WidgetListsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WidgetListsApiFp(configuration);
    return {
        /**
         * API for managing widget lists
         * @param {WidgetListsApiWidgetListsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetListsPartialUpdate(requestParameters, options) {
            return localVarFp.widgetListsPartialUpdate(requestParameters.id, requestParameters.PatchedWidgetListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing widget lists
         * @param {WidgetListsApiWidgetListsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetListsRetrieve(requestParameters, options) {
            return localVarFp.widgetListsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * API for managing widget lists
         * @param {WidgetListsApiWidgetListsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        widgetListsUpdate(requestParameters, options) {
            return localVarFp.widgetListsUpdate(requestParameters.id, requestParameters.WidgetListRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WidgetListsApi - object-oriented interface
 * @export
 * @class WidgetListsApi
 * @extends {BaseAPI}
 */
export class WidgetListsApi extends BaseAPI {
    /**
     * API for managing widget lists
     * @param {WidgetListsApiWidgetListsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetListsApi
     */
    widgetListsPartialUpdate(requestParameters, options) {
        return WidgetListsApiFp(this.configuration).widgetListsPartialUpdate(requestParameters.id, requestParameters.PatchedWidgetListRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * API for managing widget lists
     * @param {WidgetListsApiWidgetListsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetListsApi
     */
    widgetListsRetrieve(requestParameters, options) {
        return WidgetListsApiFp(this.configuration).widgetListsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * API for managing widget lists
     * @param {WidgetListsApiWidgetListsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetListsApi
     */
    widgetListsUpdate(requestParameters, options) {
        return WidgetListsApiFp(this.configuration).widgetListsUpdate(requestParameters.id, requestParameters.WidgetListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map